<template>
  <div class="dealer-list">
    <div v-if="loading"><LoadingState /></div>
    <div v-else-if="dealers.length">
      <p class="result-count">{{ $store.getters.t('found') }} {{ dealers.length }} {{ $store.getters.t(itemLabelKey) }}</p>
      <article v-for="dealer in displayedDealers" :key="dealer.id" class="dealer-card">
        <h3>{{ dealer.name || '--' }}</h3>
        <p>{{ [dealer.country || dealer.city, dealer.address].filter(Boolean).join(' · ') || '--' }}</p>
        <p v-if="dealer.phone || dealer.email">{{ [dealer.phone, dealer.email].filter(Boolean).join(' · ') }}</p>
        <p v-if="dealer.businessHours">{{ dealer.businessHours }}</p>
        <p v-if="dealer.description">{{ dealer.description }}</p>
      </article>
      <nav v-if="!isMobile && totalPages > 1" class="dealer-pagination" aria-label="Pagination">
        <button type="button" :disabled="currentPage === 1" :aria-label="$store.getters.t('previousPage')" @click="setPage(currentPage - 1)"><span aria-hidden="true">&#8249;</span></button>
        <span v-for="item in paginationItems" :key="item.key" class="dealer-pagination__slot">
          <button v-if="item.type === 'page'" type="button" :class="{ active: item.value === currentPage }" :aria-current="item.value === currentPage ? 'page' : null" @click="setPage(item.value)">{{ item.value }}</button>
          <span v-else class="dealer-pagination__ellipsis" aria-hidden="true">...</span>
        </span>
        <button type="button" :disabled="currentPage === totalPages" :aria-label="$store.getters.t('nextPage')" @click="setPage(currentPage + 1)"><span aria-hidden="true">&#8250;</span></button>
      </nav>
    </div>
    <EmptyState v-else />
  </div>
</template>

<script>
import LoadingState from './LoadingState.vue'
import EmptyState from './EmptyState.vue'

export default {
  name: 'DealerList',
  components: { LoadingState, EmptyState },
  props: {
    dealers: { type: Array, default: () => [] },
    loading: Boolean,
    itemLabelKey: { type: String, default: 'stores' }
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 5,
      isMobile: typeof window !== 'undefined' ? window.matchMedia('(max-width: 768px)').matches : false,
      mobileMedia: null
    }
  },
  computed: {
    totalPages () { return Math.max(1, Math.ceil(this.dealers.length / this.pageSize)) },
    paginationItems () {
      const total = this.totalPages
      let pages
      if (total <= 7) {
        pages = Array.from({ length: total }, (item, index) => index + 1)
      } else if (this.currentPage <= 4) {
        pages = [1, 2, 3, 4, 5, total]
      } else if (this.currentPage >= total - 3) {
        pages = [1, total - 4, total - 3, total - 2, total - 1, total]
      } else {
        pages = [1, this.currentPage - 1, this.currentPage, this.currentPage + 1, total]
      }
      return pages.reduce((items, page, index) => {
        if (index && page - pages[index - 1] > 1) {
          items.push({ type: 'ellipsis', key: `ellipsis-${page}` })
        }
        items.push({ type: 'page', value: page, key: `page-${page}` })
        return items
      }, [])
    },
    displayedDealers () {
      if (this.isMobile) return this.dealers
      const start = (this.currentPage - 1) * this.pageSize
      return this.dealers.slice(start, start + this.pageSize)
    }
  },
  watch: {
    dealers () { this.currentPage = 1 }
  },
  mounted () {
    this.mobileMedia = window.matchMedia('(max-width: 768px)')
    if (this.mobileMedia.addEventListener) this.mobileMedia.addEventListener('change', this.handleViewportChange)
    else this.mobileMedia.addListener(this.handleViewportChange)
  },
  beforeDestroy () {
    if (!this.mobileMedia) return
    if (this.mobileMedia.removeEventListener) this.mobileMedia.removeEventListener('change', this.handleViewportChange)
    else this.mobileMedia.removeListener(this.handleViewportChange)
  },
  methods: {
    setPage (page) {
      this.currentPage = Math.min(Math.max(page, 1), this.totalPages)
    },
    handleViewportChange (event) {
      this.isMobile = event.matches
      this.currentPage = 1
    }
  }
}
</script>
